<template>
	<div
		class="ms-input-multi flex ms-editor"
		:class="{ isValid: errorMulti.isValid }"
	>
		<div class="ms-input-groups">
			<div
				class="ms-input-groups-item"
				v-for="(item, index) in listConfirmText"
				:key="index"
			>
				<div class="item-text">{{ item.value }}</div>
				<div
					class="icon-input ml-2"
					v-tooltip="{
						content: item.message,
						show: showTooltip(item),
						classes: `error`,
					}"
					v-show="item.isValid"
				>
					div
				</div>
				<div
					class="item-icon mi-new mi-16 mi-icon-delete-16 mr-2 cursor-pointer"
					@click.stop="deSelect(item)"
				></div>
			</div>
			<input
				ref="input"
				class="ms-input"
				:placeholder="placeholder"
				v-model="internalText"
				v-on="listeners"
				:readonly="readonly"
				:class="{ readOnly: readonly }"
				@focus="autoFocusInput"
			/>
			<div
				class="icon-input"
				v-tooltip="{
					content: errorMulti.message,
					show: focused,
					classes: `error`,
				}"
				v-show="errorMulti.isValid"
				@click="clickIcon"
			>
				<div class="mi mi-24 mi-red-tick"></div>
			</div>
		</div>
	</div>
</template>
<script>
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
import { isNullOrEmpty } from '@/common/objectUtil';
export default {
	name: 'msInputMulti',
	extends: msBaseComponent,
	props: {
		/**
		 * V-model bắn ra ngoài binding 2 chiều
		 */
		value: {
			default: () => [],
		},
		/**
		 * Hiện thị chũ mờ ở dưới ô input
		 * Created by LTDAT(22.06.2020)
		 */
		placeholder: {
			default: null,
			type: [Number, String],
		},
		disabled: {
			default: false,
			type: Boolean,
		},
		type: {
			default: null,
			type: String,
		},
		//class chứa icon
		icon: {
			default: null,
			type: String,
		},
		//input chỉ đọc không cho nhập
		readonly: {
			default: false,
			type: Boolean,
		},
		//Giới hạn nhập của ô input
		maxLength: {
			default: null,
			type: Number,
		},
		//Input bắt buộc có giá trị
		isRequired: {
			default: false,
			type: Boolean,
		},

		nameItem: {
			default: null,
			type: String,
		},
		//rule để validate từng giá trị trong multi
		rulesItem: {
			type: String,
			default: null,
		},
		autoFocus: {
			default: false,
			type: Boolean,
		},
	},
	data() {
		return {
			internalText: null,
			focused: false,
			isLongText: false,
			listConfirmText: [],
			errorMulti: {},
		};
	},
	updated() {
		const me = this;
		me.checkingLongText();
	},
	mounted() {
		const me = this;
		me.checkingLongText();
	},
	computed: {
		inputTooltip() {
			const me = this;
			if (me.isLongText) {
				return me.internalText;
			}
			return null;
		},
		listeners() {
			const me = this;
			return {
				blur: (event) => me.onBlur(event),
				focus: (event) => this.onFocus(event),
				change: (event) => me.onChange(event),
				keydown: (event) => me.onKeydown(event),
			};
		},
	},
	methods: {
		showTooltip(item) {
			const me = this;
			let itemError = [...me.listConfirmText]
				.reverse()
				.find((x) => x.isValid == true);
			if (itemError && itemError.value == item.value) {
				return me.focused;
			} else {
				return false;
			}
		},

		clickIcon(e) {
			const me = this;
			me.$emit('change', me.internalText, e);
		},
		checkingLongText() {
			const me = this;
			if (me.$refs.input) {
				if (me.$el.offsetWidth < me.$refs.input.scrollWidth) {
					me.isLongText = true;
				} else {
					me.isLongText = false;
				}
			}
		},
		//Sự kiện focus vào ô input
		onFocus(e) {
			const me = this;
			me.focused = true;
			me.$emit('focus', e);
		},
		//Sự kiên blur ra ngoài ô input
		onBlur(e) {
			const me = this;
			me.focused = false;
			me.$emit('blur', e);
		},

		//Sự kiện xử lí khi enter
		onKeydown(e) {
			const me = this;
			me.$emit('keydown', e);
			switch (e.which) {
				case 13: //Enter
					event.preventDefault();
					me.addNewText(me.internalText);
					break;
				case 32: //Phím cách
					event.preventDefault();
					me.addNewText(me.internalText);
					break;
			}
		},

		//Sự kiện change input
		onChange(e) {
			const me = this;
			event.preventDefault();
			me.addNewText(me.internalText);
		},

		addNewText(valueItem) {
			const me = this;
			if (!isNullOrEmpty(valueItem)) {
				let newObj = {
					value: valueItem,
				};
				me.validateInput(newObj);
				me.listConfirmText.push(newObj);
				me.$emit('input', me.listConfirmText);
			}
			me.validateInputGroup();
			me.internalText = null;
			me.autoFocusInput();
		},

		validateInputGroup() {
			const me = this;
			if (me.isRequired && me.listConfirmText.length == 0) {
				me.errorMulti = {
					message: me.name + ` ${me.$t('i18nCommon.notinputempty')}`,
					isValid: true,
					element: me.$refs.input,
				};
				me.$set(me.errorProvider, 'isValid', me.errorMulti.isValid);
				me.$set(me.errorProvider, 'message', me.errorMulti.message);
				me.$set(me.errorProvider, 'element', me.errorMulti.element);
			} else {
				me.errorMulti = {};
				me.errorProvider = {};
			}
			return me.errorProvider;
		},

		validateInput(data) {
			const me = this;
			let listRules = [],
				rulesValidate = null,
				ret = false;
			if (me.rulesItem) {
				listRules = me.rulesItem.split('|');
			}
			for (let i = 0; i < listRules.length; i++) {
				ret = !me.validateRule(listRules[i], data.value, null);
				if (ret) {
					rulesValidate = listRules[i];
					break;
				}
			}
			if (ret) {
				if (me.$t('i18nValidate.messages')[rulesValidate]) {
					me.$set(
						data,
						'message',
						me
							.$t('i18nValidate.messages')
							[rulesValidate](me.nameItem ? me.nameItem : me.name)
					);
				}
				me.$set(data, 'isValid', true);
			} else {
				me.$set(data, 'isValid', false);
				me.$set(data, 'message', null);
			}
			me.$set(data, 'element', me.$refs.input);
			return data;
		},

		validate() {
			const me = this;
			if (me.disabled) {
				me.errorProvider = {};
				return me.errorProvider;
			}
			if (!isNullOrEmpty(me.internalText)) {
				me.addNewText(me.internalText);
			}
			me.validateInputGroup();
			if (me.listConfirmText.length > 0) {
				me.listConfirmText.forEach((element) => {
					me.validateInput(element);
				});
			}
			if (me.errorProvider && me.errorProvider.isValid) {
				return me.errorProvider;
			} else if (me.listConfirmText.find((x) => x.isValid == true)) {
				return me.listConfirmText;
			} else {
				return {};
			}
		},

		//Reset lại giá trị về ban đầu
		reset() {
			const me = this;
			me.internalText = null;
			me.listConfirmText = [];
			me.errorMulti = {};
			me.errorProvider = {};
		},
		//Set giá trị cho ô input
		setValue(value) {
			const me = this;
			me.internalText = value;
		},

		deSelect(item) {
			let me = this;
			me.listConfirmText.remove(item);
			me.$emit('input', me.listConfirmText);
			me.validateInputGroup();
			//Focus vào input trên combobox nếu cần
			me.autoFocusInput();
		},

		/**
		 * Hàm sử lí việc autoFocus ô input
		 */
		autoFocusInput(e) {
			const me = this;
			//Focus vào ô input
			if (me.autoFocus) {
				me.$ms.commonFunc.focusFirstControl(me.$el);
			}
		},
	},
	watch: {
		internalText: {
			handler(newVal, oldVal) {
				const me = this;
			},
		},
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				if (newVal.length == 0 && me.listConfirmText.length > 0) {
					me.listConfirmText = [];
				}
				if (newVal.length > 0 && me.listConfirmText.length == 0) {
					newVal.forEach((item) => {
						me.listConfirmText.push(item);
					});
				}
			},
		},
		disabled: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.validate();
				}
			},
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msInputMulti.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msInputMulti.scss';
}
</style>

